import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { homeForRole } from '../route/RoleRoute';
import { PoweredBy } from './Branding';
import TDW_logo from '../../assets/Images/vitals_portal_logo.png';

/** Sidebar logo: links to the signed-in user's dashboard. */
export const SidebarLogo = () => {
    const role = useSelector((state) => state.auth?.user?.role);
    return (
        <>
        <div className="logo-details">
            <Link to={homeForRole(role)} aria-label="Go to my dashboard" title="Go to my dashboard" data-testid="sidebar-logo-link" style={{ cursor: 'pointer', display: 'block', margin: '0 auto' }}>
                <img src={TDW_logo} className="logoImg" alt="Vitals Portal" style={{ cursor: 'pointer' }} />
            </Link>
        </div>
        <PoweredBy />
        </>
    );
};

/** Menu list whose first entry is always the role's dashboard; other items follow in the given order. */
export const SidebarNavList = ({ dashboard, badge, children }) => (
    <ul className="nav-links">
        <li className="nav_link" data-testid="sidebar-dashboard-item">
            <NavLink key="dashboard" to={dashboard.to} activeClassName="link-name-active">
                <i className={dashboard.icon} style={{ color: dashboard.color || '#FEFFFF', fontSize: '24px' }}></i>
                <span className="link_name" title={dashboard.label}>{dashboard.label}</span>{badge}
            </NavLink>
        </li>
        {children}
    </ul>
);
